var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zj-camera-player is-playback"},[_c('div',{ref:"playerContainer",staticClass:"zj-camera-player-container",staticStyle:{"width":"100%","height":"100%"}},[_c('div',{ref:"player",on:{"dblclick":_vm.onDblClick}}),_c('div',{staticClass:"zj-camera-player-toolbar clear"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }